module.exports = __webpack_public_path__ + "media/images/proof_links/soundcloud-6102c30b3003f6eb4c97bd84994f3f4d.svg";